import { render, staticRenderFns } from "./selectUserType.vue?vue&type=template&id=90186474&scoped=true"
import script from "./selectUserType.vue?vue&type=script&lang=js"
export * from "./selectUserType.vue?vue&type=script&lang=js"
import style0 from "./selectUserType.vue?vue&type=style&index=0&id=90186474&prod&lang=scss&scoped=true"
import style1 from "./selectUserType.vue?vue&type=style&index=1&id=90186474&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90186474",
  null
  
)

export default component.exports